import * as $ from "jquery";

export function showReferrals() {
    const $button = $("#refercode-show");
    const $form = $("#refercode-entry");
    const $title = $("#refercode-title");
    const $p = $("#refercode-p");

    const doShowRefer = function () {
        $button.hide();
        $form.show();
        $title.show();
        $p.show();
    };

    if ($("#ReferCode").val() || $("#ReferStudentName").val()) {
        doShowRefer();
    }

    $button.on("click", function () {
        doShowRefer();
    });
}
